// src/components/AppTeaser.jsx
import React from "react";

/*
  App teaser intentionally disabled.
  App will be introduced in a later phase.
*/

export default function AppTeaser() {
  return null;
}
